module.exports = __webpack_public_path__ + "static/cosyclamb1-cdbaf9832be4aff6d03723748b4dc05f.jpeg";